export default function html(formData, logoBase64, logoBase) {
  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1">
      <title>Rainmaker Welcome</title>

      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;600;700&display=swap" rel="stylesheet">

      <style>
        body {
          margin: 0;
          padding: 0;
          background-color: #ffffff;
          font-family: 'Noto Sans', sans-serif;
          color: #4F4F4F;
          line-height: 28px;

        }
        .header {
        background: url("https://firebasestorage.googleapis.com/v0/b/rainfall-production.appspot.com/o/StarAura%2Femail%20header%20background.png?alt=media&token=74463d4a-656c-4347-96a6-9affc289aec5");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  
          
        }
        .header img {
          height: 170px !important;
        }

        @media only screen and (max-width: 600px) {
  .header img {
    height: 70px !important;   /* smaller on mobile */
  }
}
        .content-wrapper {
          padding: 40px 20px;
        }
        .content {
          max-width: 700px;
          width: 100%;
          text-align: left;
          margin: 0 auto;
        }
        .content h1 {
          font-size: 16px;
          color: #000000;
          font-weight: 700;
          font-family: Noto Sans;
        } 
        .content p {
          font-size: 16px;
          font-family: Noto Sans;
          line-height: 28px;
          color: #000000;
          margin: 16px 0;
        }
        .content b {
          color: #000000;
        }
        .content a {
          color: #6B35A4;
          text-decoration: none;
          font-weight: bold;
        }
        .content a:hover {
          text-decoration: underline;
        }
        .steps {
          margin: 0;
          padding: 0;
        }
        .step-item {
          margin: 0 !important;
          padding: 0 !important;
          line-height: 1.5 !important;
          font-size: 16px !important;
          color: #000000 !important;
          font-family: Noto Sans;
        }
        .step-title {
          font-weight: bold;
        }
        .footer {
          text-align: center;
          font-size: 12px;
          color: #4F4F4F;
          padding: 30px 20px;
          background-color: #F8F8F8;
        }
      </style>
    </head>
    <body>



      <div  class="header">
        <img src="https://firebasestorage.googleapis.com/v0/b/rainfall-production.appspot.com/o/StarAura%2Femail%20header%20(1).png?alt=media&token=562f9e6a-1fdd-4400-bea6-81f3f2105985" />
      </div>


      <div class="content-wrapper">
        <div class="content">
          <h1 style="font-family: Noto Sans">Thanks for signing up for Star Aura - you’re now part of the creator-first movement.</h1>
          <p style="font-family: Noto Sans">
          Star Aura is the Personal AI of the artists, athletes, and creators you love, built and governed by them. It lets you connect with them in their own voice, in a direct and authentic way
          </p>

          <p style="font-family: Noto Sans">
          You’ll be among the first to experience it.
          </p>

          
          <p style="font-family: Noto Sans">
          In the meantime,<a href="https://www.instagram.com/rainfall.one/"> follow us on Instagram </a>for early previews and updates.
          </p>

         
         <p style="font-family: Noto Sans">
We’re grateful you’re here and excited to share what’s coming.         
 </p>
          <p style="font-family: Noto Sans">- The Star Aura ✦ Rainfall Team</p>
          
        </div>
      </div>

      <div class="footer">
        <p>
          Copyright © Rainfall AG<br>
          Sent to: <a href="mailto:${formData.email}">${formData.email}</a><br>
          You have received this email since you signed up to the Rainmaker Pool.<br>
          Our address:<br>
          Dammstrasse 16, 6300 Zug<br>
          Switzerland
        </p>
      </div>
    </body>
    </html>
  `;
}